/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { ChangeDetectionStrategy, Component, Directive, ElementRef, Renderer2, ViewEncapsulation, } from '@angular/core';
import { mixinColor } from '@angular/material/core';
export class MatToolbarRow {
}
MatToolbarRow.decorators = [
    { type: Directive, args: [{
                selector: 'mat-toolbar-row',
                exportAs: 'matToolbarRow',
                host: { 'class': 'mat-toolbar-row' },
            },] },
];
/**
 * @nocollapse
 */
MatToolbarRow.ctorParameters = () => [];
function MatToolbarRow_tsickle_Closure_declarations() {
    /** @type {?} */
    MatToolbarRow.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatToolbarRow.ctorParameters;
}
/**
 * \@docs-private
 */
export class MatToolbarBase {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    constructor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
    }
}
function MatToolbarBase_tsickle_Closure_declarations() {
    /** @type {?} */
    MatToolbarBase.prototype._renderer;
    /** @type {?} */
    MatToolbarBase.prototype._elementRef;
}
export const /** @type {?} */ _MatToolbarMixinBase = mixinColor(MatToolbarBase);
export class MatToolbar extends _MatToolbarMixinBase {
    /**
     * @param {?} renderer
     * @param {?} elementRef
     */
    constructor(renderer, elementRef) {
        super(renderer, elementRef);
    }
}
MatToolbar.decorators = [
    { type: Component, args: [{selector: 'mat-toolbar',
                exportAs: 'matToolbar',
                template: "<div class=\"mat-toolbar-layout\"><mat-toolbar-row><ng-content></ng-content></mat-toolbar-row><ng-content select=\"mat-toolbar-row\"></ng-content></div>",
                styles: [".mat-toolbar{display:flex;box-sizing:border-box;width:100%;padding:0 16px;flex-direction:column}.mat-toolbar .mat-toolbar-row{display:flex;box-sizing:border-box;width:100%;flex-direction:row;align-items:center;white-space:nowrap}.mat-toolbar{min-height:64px}.mat-toolbar-row{height:64px}@media (max-width:600px){.mat-toolbar{min-height:56px}.mat-toolbar-row{height:56px}}"],
                inputs: ['color'],
                host: {
                    'class': 'mat-toolbar',
                    'role': 'toolbar'
                },
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                preserveWhitespaces: false,
            },] },
];
/**
 * @nocollapse
 */
MatToolbar.ctorParameters = () => [
    { type: Renderer2, },
    { type: ElementRef, },
];
function MatToolbar_tsickle_Closure_declarations() {
    /** @type {?} */
    MatToolbar.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatToolbar.ctorParameters;
}
//# sourceMappingURL=toolbar.js.map